import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AirbnbToastService, AirbnbToast } from '../../services/airbnb-toast.service';

@Component({
  selector: 'app-airbnb-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-container">
      <div
        *ngFor="let toast of toasts; trackBy: trackById"
        class="toast"
        [class.toast--removing]="toast.removing">

        <div class="toast__content">
          <div class="toast__icon">
            <i *ngIf="toast.severity === 'success'" class="pi pi-check"></i>
            <i *ngIf="toast.severity === 'error'" class="pi pi-times"></i>
            <i *ngIf="toast.severity === 'warn'" class="pi pi-exclamation-triangle toast__icon--warn"></i>
            <i *ngIf="toast.severity === 'info' || toast.severity === 'contrast'" class="pi pi-info-circle"></i>
          </div>

          <div class="toast__text">
            <p class="toast__summary">{{ toast.summary }}</p>
            <p *ngIf="toast.detail" class="toast__detail">{{ toast.detail }}</p>
          </div>

          <button class="toast__close" (click)="dismiss(toast)">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .toast-container {
      position: fixed;
      bottom: 96px;
      left: 16px;
      right: 16px;
      z-index: 9999;
      pointer-events: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }

    .toast {
      pointer-events: auto;
      max-width: 400px;
      width: 100%;
      animation: slideUp 0.2s ease-out forwards;
    }

    .toast--removing {
      animation: slideDown 0.15s ease-in forwards;
    }

    .toast__content {
      background: #222;
      border-radius: 12px;
      padding: 12px 16px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .toast__icon {
      flex-shrink: 0;
      color: #fff;
      font-size: 16px;
    }

    .toast__icon--warn {
      color: #fbbf24;
    }

    .toast__text {
      flex: 1;
      min-width: 0;
    }

    .toast__summary {
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      line-height: 1.4;
      margin: 0;
    }

    .toast__detail {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 1.4;
      margin: 2px 0 0;
    }

    .toast__close {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: transparent;
      border: none;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.6);
      transition: background 0.15s, color 0.15s;
    }

    .toast__close:hover {
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
    }

    .toast__close i {
      font-size: 12px;
    }

    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes slideDown {
      from {
        opacity: 1;
        transform: translateY(0);
      }
      to {
        opacity: 0;
        transform: translateY(20px);
      }
    }
  `]
})
export class AirbnbToastComponent implements OnInit, OnDestroy {
  toasts: AirbnbToast[] = [];
  private subscription?: Subscription;

  constructor(private _toastService: AirbnbToastService) {}

  ngOnInit() {
    this.subscription = this._toastService.toasts$.subscribe(toasts => {
      this.toasts = toasts;
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  dismiss(toast: AirbnbToast) {
    this._toastService.remove(toast.id);
  }

  trackById(index: number, toast: AirbnbToast): string {
    return toast.id;
  }
}
